import "./About_Banner.css";
import { Banners } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import { Link } from "react-router-dom";

const About_banner = () => {
  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [banner, setBanner] = useState({});

  console.log("About banner", banner);

  const getBanner = async () => {
    const res = await Banners();

    if (res?.success) {
      setBanner(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  return (
    <section className="about_banner ">
      <Link to={"/contact-us"}>
        <div className="banner_wrapper">
          <img
            src={IDS?.IMG_URL + banner?.image}
            alt="About_Banner"
            className="img_wrapper"
          />
        </div>
      </Link>
    </section>
  );
};

export default About_banner;
